import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import {AppService} from '../../services/app.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private router: Router,
    private appsService: AppService
  ) {
  }

  ngOnInit(): void {

    this.http.get<any>(environment.apiUrl + '/customer/location').subscribe(
      data => {
        var userCity = data.city;

        let browserCity = this.appsService.getCurrentCity(true);
        if (!browserCity) {

          if (userCity) {
            const cities = ['Mumbai', 'Bangalore', 'Delhi', 'Pune'];
            if (cities.includes(userCity)) {

              localStorage.setItem('city', userCity);
              this.appsService.setlocationSetByTheUser();
              this.router.navigate(['/' + userCity.toLowerCase() + '/deals']);
            } else {
              this.router.navigate(['mumbai/deals']);
            }
          }
        } else {
          this.router.navigate(['/' + browserCity.toLowerCase() + '/deals']);
        }
      },
      error => {
        console.error('There was an error!', error);
        console.error(error.error);
        this.router.navigate(['/mumbai/deals']);
      });
  }
}
